import { useTranslation } from 'react-i18next'

export function LanguageSwitch() {
  const { t, i18n } = useTranslation()
  const isZh = i18n.language === 'zh-TW' || i18n.language?.startsWith('zh')
  const isEn = i18n.language.startsWith('en')

  return (
    <div className="lang-switch" role="group" aria-label={t('profile.language')}>
      <button
        type="button"
        className={isZh ? 'active' : ''}
        aria-pressed={isZh}
        onClick={() => void i18n.changeLanguage('zh-TW')}
      >
        {t('lang.zh')}
      </button>
      <button
        type="button"
        className={isEn ? 'active' : ''}
        aria-pressed={isEn}
        onClick={() => void i18n.changeLanguage('en')}
      >
        {t('lang.en')}
      </button>
    </div>
  )
}
